/*
 * Groups
 * 
 * @author: Elton Jain
 */
/* global define, require */

define('Groups',[
    'jquery',
    'UI',
    'modules/common/Constants', // Site constants
    'Auth',
    'Helper',
    'JSTemplate',
    'Validation',
    'Config',
    'Toastr',
    'History'
], function($, UI, Constants, Auth, Helper, template, Validation, Config, Toastr, History) {
    'use strict';

    var langs = Config.get('lang'),
        grpCreateValidationRules = {
            name: {
                presence: {
                    message: '^Topic name cannot be empty'
                }
            },
            description: {
                presence: {
                    message: '^Topic description cannot be empty'
                }
            },
            categoryId: {
                presence: {
                    message: '^Select topic category'
                }
            }

        },
        userData = Auth.getUser(),

        Groups = {
            $elePopupGroupJoin: $('#popupJoinGroup'),
            $eleGroupDash: $('#groupDash'),
            joinGroupCallback: null,

            init: function() {
                this.bindEvents();
                if (/^(group|group.tv_episode)$/.test(Config.get('page.route')) && Config.get('page.urlParams.new')) {
                    if (history) {
                        history.pushState('', document.title, Config.get('page.pageUrl'));
                    }
                }

                Groups.AMA();
                Groups.Members.init();
                Groups.Avatar.init();
            },
            bindEvents: function() {
                var base = this;
                // Join Group
                UI.$b.on('click', '.btn-join-group', function(e) {
                    
                    e.preventDefault();
                    if (!Auth.checkLoginRequired({source: 'follow topic'})) {
                        return false;
                    }

                    var $btn = $(this),
                        groupId = $btn.data('group-id'),
                        isFollowing = $btn.is('.following') ? true : false;

                    if(!isFollowing) { // Follow
                        $btn.addClass('following');
                        if ($btn.is('.prompt')) {
                            base.showJoinGroupPopup({
                                name: $btn.data('name'),
                                image: $btn.data('image'),
                                id: groupId
                            }, function() {
                                // if($btn.data('url') && $btn.data('url') !== '') {
                                    // window.location.href = $btn.data('url');
                                // }
                            });
                        } else {
                            base.joinGroup(groupId, function () {
                                // If is AMA
                                if(window._gtap.data.pageGroupData && window._gtap.data.pageGroupData.ama_info) {
                                    Helper.showInvitePopup({
                                        message: "Would you like to invite some of your friends to this broadcast?",
                                        url: window._gtap.data.pageGroupData.url
                                    });
                                }
                            });
                            return false;
                        }
                    } else { // Unfollow
                        if (confirm(langs.warn_unfollow)) {
                            base.leaveGroup(groupId, function(response) {
                                $btn.removeClass('following');
                                // if(currentPage === 'groups.suggestion' || currentPage === 'home') {
                                //     that.removeClass('btn-leave-group').addClass('btn-quick-join-group btn-blue');
                                //     that.text('+ Follow');
                                //     that.removeClass('active following');
                                // }
                                new Toastr({
                                    message: response.message
                                });
                            });
                        }
                    }

                    return false;
                });

                // If on group page then provide popup for more settings
                // TODO
                // route = group*
                if(/^(group|group.tv_episode|group.about|group.members|topic)$/.test(Config.get('page.route'))) {
                    $('#btnGroupMoreOptions').on('click', function(e) {
                        e.preventDefault();
                        var html = template('tplMoreSettingsPopUp', {
                            groupData: window._gtap.data.groupPopUp,
                            langs: langs
                        });
                        UI.$b.append(html);
                        History.pushState({
                            url: window.location.href,
                            popupId: 'popup-action-menu'
                        });
                    });

                    UI.$b.on('click', '.share-group', function() {
                        alert('You\'ll be able to share this topic');
                    });
                }


                // Join Group Popup - Join
                UI.$b.on('click', '.btn-quick-join-group', function(e) {
                    e.preventDefault();
                    var currentPage = Config.get('page.route'),
                        $btn = $(this),
                        groupId = $btn.data('group-id');

                    if (!groupId) {
                        throw ('Topic not specified');
                    }

                    base.joinGroup(groupId, function(response) {

                        if (currentPage === 'groups.suggestion' || currentPage === 'home') {
                            $btn.removeClass('btn-quick-join-group btn-blue').addClass('btn-leave-group');
                            $btn.text(langs.un_follow);
                            $btn.addClass('active following');

                            new Toastr({
                                'message': response.message
                            });
                        } else {
                            if (base.joinGroupCallback) {
                                base.joinGroupCallback();
                            }

                            base.closeJoinGroupPopup();
                        }

                    });

                    return false;
                });
                // Join Group Popup - Close
                base.$elePopupGroupJoin.on('click', '.btn-close', function() {
                    base.closeJoinGroupPopup();
                    return false;
                });

                // Leave Group
                UI.$b.on('click', '.btn-leave-group', function(e) {
                    var that = $(this),
                        groupId = that.data('group-id'),
                        currentPage = Config.get('page.route');

                    e.preventDefault();

                    if (confirm(langs.warn_unfollow)) {
                        if(currentPage === 'groups.suggestion' || currentPage === 'home') {
                            base.leaveGroup(groupId, function(response) {
                            if(currentPage === 'groups.suggestion' || currentPage === 'home') {
                                that.removeClass('btn-leave-group').addClass('btn-quick-join-group btn-blue');
                                that.text(langs.follow_btn);
                                that.removeClass('active following');

                                new Toastr({
                                    message: response.message
                                });
                            }
                        });
                        } else {
                            base.leaveGroup(groupId);
                        }
                        
                    }

                    return false;
                });

                // Form Create Group
                UI.$b.on('submit', '#frmCreateGroup', function() {
                    var f = this,
                        $f = $(f),
                        api = '/ajax/group/create';

                    // Validate
                    var validation = new Validation({
                        form: $(this),
                        allConstraints: grpCreateValidationRules
                    });

                    if (validation.isValid() !== true) {
                        return;
                    }

                    $.post(api, $f.serialize(), function(response) {
                        var mixpanelData = {};

                        if (response.status === true) {
                            mixpanelData = {
                                group_id: response.response.id,
                                group_name: response.response.name,
                                user: userData.fullname,
                                user_id: userData.id,
                                is_private: response.response.is_private
                            };

                            require(['Mixpanel'], function(MixPanel) {
                                MixPanel.hit('group_create', mixpanelData, function() {
                                    window.location.href = response.redirect_url;
                                });
                            });

                        } else {
                            alert(response.message);
                        }
                    });
                });

                // Avatar Form
                // if ($('.image-upload-card').length && 5 === 6) {
                //     require(['modules/common/ImageForm'], function(ImageForm) {

                //         var $eleImageForm = $('#frmGroupAvatar'),
                //             // $eleImagePreview = $('#imageUploadCardPreview'),
                //             $eleImageSelect = $('#fileImageUpload'),
                //             api = $eleImageForm.attr('action');

                //         new ImageForm({
                //             previewContainer: '#imageUploadCardPreview',
                //             selectFileEle: '#fileImageUpload',
                //             fileTriggerEle: '#btnImageUploadSelect',
                //             maxImageAllowed: 1,
                //             maxImageError: '',
                //             onInit: function() {
                //                 var imgform = this;

                //                 $('#listDefaultAvatars').on('click', 'li', function() {
                //                     var $ele = $(this),
                //                         url = $ele.data('image'),
                //                         $elGrpLogo = $('#imgGrpHeadLogo');

                //                     $eleImageSelect.val('');
                //                     imgform.setImageQueue([]);
                //                     if ($elGrpLogo.length) {
                //                         $elGrpLogo.attr('src', url);
                //                     }
                //                     $('#txtImageUrl').val(url);
                //                 });

                //             },
                //             form: {
                //                 ele: '#frmGroupAvatar',
                //                 api: api,
                //                 fileElePrefix: 'image',
                //                 extraData: {},
                //                 callback: function() {
                //                     var response = this;
                //                     // console.log(response);
                //                     if (response.status === true) {
                //                         window.location.href = response.redirect_url;
                //                     } else {
                //                         alert(response.message);
                //                     }
                //                 }
                //             },
                //         });


                //     });
                // }

                $('#listDefaultBackgrounds').on('click', 'li', function() {
                    var $ele = $(this),
                        bg = $ele.data('bg');
                    $('#txtBackground').val(bg);
                    Groups.$eleGroupDash.css('background', bg);
                    // Groups.$eleGroupDash.addClass('theme-' + Helper.getColorTheme(bg));
                    // $ele.addClass('active');
                });

                // Save Background
                UI.$b.on('submit', '#frmGroupBackground', function() {
                    var f = this,
                        $f = $(f),
                        api = $f.attr('action');

                    if (!f.background.value) {
                        alert('Please select a background to proceed');
                        f.background.focus();
                        return false;
                    }

                    $.post(api, $f.serialize(), function(response) {
                        // console.log(response);
                        if (response.status === true) {
                            window.location.href = response.redirect_url;
                        } else {
                            alert(response.message);
                        }
                    });
                });

                // Expand group list
                UI.$b.on('click', '.expand-list', function() {
                    var allLi = $(this).siblings().not('.visible');
                    if ($(this).hasClass('collapse')) {
                        allLi.slideDown('500');
                        //$(this).removeClass('collapse').addClass('expand');
                    } else {
                        allLi.slideUp('500');
                        //$(this).removeClass('expand').addClass('collapse');
                    }

                    $(this).toggleClass('collapse expand');

                });



            },
            joinGroup: function(groupId, callback) {
                var base = this,
                    // user = User.getUser(),
                    api = '/ajax/group/join',
                    mixpanelData = {};

                if (!Auth.checkLoginRequired({source: 'follow topic'})) {
                    return false;
                }

                $.post(api, {
                    group_id: groupId
                }, function(response) {

                    if (response.status === true) {
                        // Joined
                        // Reload if group page
                        mixpanelData = {
                            user: Auth.getUser().fullname,
                            user_id: Auth.getUser().id,
                            topic_id: groupId,
                            topic_name: response.response.group_info.name
                        };

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('follow_topic', mixpanelData, function () {
                                if (callback) {
                                    callback(response);
                                } else if (base.joinGroupCallback) {
                                    base.joinGroupCallback();
                                } else {
                                    window.location.reload();
                                }
                                base.joinGroupCallback = null;
                            });
                        });

                        if(response.response.group_info.ama_info) {
                            new Toastr({
                                'message': response.message,
                                'timeout': 4000
                            });    
                        }
                        


                    } else if (response.status === false) {
                        if (response.status_code === Constants.status_code.no_auth_login) {
                            Auth.showLoginPopup(true, {source: 'topic follow'});
                        } else {
                            new Toastr({
                                'message': response.message,
                                'class': 'toastr-error',
                                'icon': 'ion-alert'
                            });
                        }

                        return false;
                    }

                    base.closeJoinGroupPopup();
                });
            },
            leaveGroup: function(groupId, callback) {
                var user = Auth.getUser(),
                    api = '/ajax/group/leave';

                if (!Auth.checkLoginRequired({source: 'topic unfollow'})) {
                    return false;
                }

                $.post(api, {
                    group_id: groupId
                }, function(response) {
                    // console.log(response);
                    if (response.status === true) {
                        var mixpanelData = {
                            topic_id: groupId,
                            user: user.fullname,
                            user_id: user.id
                        };

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('unfollow_topic', mixpanelData, function () {
                                if(callback) {
                                    callback(response);
                                    } else {
                                        if (response.redirect_url) {
                                        window.location.href = response.redirect_url;
                                    } else {
                                        window.location.reload();
                                    }    
                                }
                            });
                        });
                    } else if (response.status === false) {
                        if (response.status_code === Constants.status_code.no_auth_login) {
                            Auth.showLoginPopup(true, {source: 'topic unfollow'});
                        } else {
                            new Toastr({
                                'message': response.message,
                                'class': 'toastr-error',
                                'icon': 'ion-alert'
                            });
                        }

                        return false;
                    }
                });
            },
            closeJoinGroupPopup: function() {
                this.$elePopupGroupJoin.hide();
            },
            showJoinGroupPopup: function(options, callback) {
                // options = (groupid, name, image, callback)
                var popupTemplate = "tplGroupJoinPopup",
                    base = this;
                if (options.length < 3) {
                    alert('Invalid request');
                    return false;
                }

                var tmplData = {
                        name: options.name,
                        image: options.image,
                        url: options.url,
                        id: options.id,
                        btnJoinLabel: options.btnJoinLabel || null
                    },
                    $popup = $(template(popupTemplate, tmplData));

                if (callback) {
                    base.joinGroupCallback = callback;
                }

                $popup.appendTo(UI.$b).addClass('open');

                return false;
            },
        };

    /**
     * Groups Avatar
     */
    Groups.Avatar = {
        objImageForm: {},
        init: function() {
            if(Config.get('page.route') === 'group.settings.avatar') {
                this.bindEvents();
            }
        },
        bindEvents: function() {
            // Upload Avatar
            var base = this,
                elGroupAvatarForm = '#frmGroupAvatar',
                elFileSelect = '#fileImageUpload',
                elSelectTrigger = '#btnImageUploadSelect',
                $elGroupHeaderLogo = $('#imgGrpHeadLogo'),
                $elGroupAvatarForm = $(elGroupAvatarForm);

            if ($elGroupAvatarForm.length) {
                UI.$b.on('submit', elGroupAvatarForm, function() {
                    var $form = $elGroupAvatarForm,
                        api = $elGroupAvatarForm.attr('action'),
                        images = base.objImageForm ? base.objImageForm.getImages() : null,
                        formData = $.extend($form.serializeArray(), {}),
                        _fd = new FormData();
                    $form.find('[type=submit]').addClass('loading');
                    $.each(images, function(i, file) {
                        _fd.append('image' + i, file);
                    });

                    $.each(formData, function(i, input) {
                        _fd.append(input.name, input.value);
                    });

                    $.ajax({
                        url: api,
                        data: _fd,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function(response) {
                            $form.find('[type=submit]').removeClass('loading');
                            // console.log(response);

                            if (response.status === true) {
                                window.location.href = response.redirect_url;
                            } else {
                                alert(response.message);
                            }
                        },
                        error: function() {
                            $form.find('[type=submit]').addClass('loading');
                        }
                    });
                    return false;
                });

                require(['ImageForm'], function(ImageForm) {
                    base.objImageForm = new ImageForm({
                        elForm: elGroupAvatarForm,
                        elFileSelect: elFileSelect,
                        elSelectTrigger: elSelectTrigger,
                        elPreviewContainer: $elGroupHeaderLogo,
                        useContainerSelf: true,
                        maxImages: 1,
                        // onChange: function() {
                        //     var imgCount = this.hasImages();
                        //     // console.log(imgCount);
                        //     if (imgCount >= 1) {

                        //     }
                        // }
                    });
                });

                // Default Avatar List to choose from
                $('#listDefaultAvatars').on('click', 'li', function() {
                    var $ele = $(this),
                        url = $ele.data('image');
                    $(elFileSelect).val('');
                    if ($elGroupHeaderLogo.length) {
                        // Use as background
                        $elGroupHeaderLogo.css('background-image', 'url(' + url + ')');
                        base.objImageForm.reset();
                    }
                    $('#txtAvatarImageUrl').val(url);
                });
            }
        }
    };

    /**
     * Groups Members List page
     * @type {Object}
     */
    Groups.Members = {
        init: function() {
            if(Config.get('page.route') === 'group.members') {
                this.bindEvents();
            }
        },
        bindEvents: function() {
            var base = this,
                groupId = Groups.$eleGroupDash.data('group'),
                $listMemberRequest = $('#lstGrpMemberRequest'),
                $listGroupMembers = $('#lstGrpMembers');

            // Approve Member request
            $listMemberRequest.on('click', '.btn-approve-member', function() {
                var $this = $(this),
                    $li = $this.parents('li'),
                    memberId = $li.data('user');

                if (confirm('Do you confirm to approve this user?')) {
                    var ajaxData = {
                        groupId: groupId,
                        userId: memberId,
                        action: 'approve'
                    };

                    base.handleMemberRequest(ajaxData, function() {
                        $li.fadeOut('slow', function() {
                            $this.parents('.actions').remove();
                            $li.prependTo($listGroupMembers).fadeIn('fast');
                        });
                    });
                }

                return false;
            });


            // Ignore Member request
            $listMemberRequest.on('click', '.btn-ignore-member', function() {
                var $this = $(this),
                    $li = $this.parents('li'),
                    memberId = $li.data('user');

                if (confirm('Are you sure you want to disapprove this request?')) {
                    var ajaxData = {
                        groupId: groupId,
                        userId: memberId,
                        action: 'ignore'
                    };

                    base.handleMemberRequest(ajaxData, function() {
                        $li.fadeOut('slow', function() {
                            $this.remove();
                        });
                    });
                }

                return false;
            });



        },
        handleMemberRequest: function(ajaxData, callback) {
            var api = '/ajax/group/handleJoinRequest';

            $.post(api, ajaxData, function(response) {
                if (response.status === true) {
                    if (callback) {
                        callback();
                    }

                } else {
                    alert(response.message);
                }
            });
        },
    };


    /**
     * AMA
     */
    // Groups.AMA = {
    //     Topic: null,
    //     $elTopicHeader: null,
    //     TIMER: null,
    //     init: function () {
    //         alert();
    //         var base = this;
    //         if(Config.get('page.route') === 'group' || Config.get('page.route') === 'group.tv_episode') {
    //             this.Topic = window._gtap.data.pageGroupData;
    //             // Only if AMA page
    //             if(parseInt(this.Topic.type) === 1) {
    //                 this.$elTopicHeader = $('#groupDash');
    //                 // if(Auth.check()) {
    //                     // Updating Date to suit firefox/safari browsers
    //                     this.Topic.ama_info.start_date = this.Topic.ama_info.start_date.replace(/-/g,'/') + " UTC";
    //                     this.Topic.ama_info.end_date = this.Topic.ama_info.end_date.replace(/-/g,'/') + " UTC";
    //                     this.stuff();
    //                 // }
    //                 this.bindEvents();
    //             } else {
    //                 this.Topic = undefined;
    //             }
    //         }

    //         /* else if(Config.get('page.route') === 'tv') {
    //             UI.$b.on('click', '#amaTvContainer .ama-thumb', function () {
    //                 var $ele = $(this);
    //                 if($ele.parent('.ama-item').is('.state-before')) {
    //                     return true;
    //                 }
    //                 var ama_id = $ele.parent('.ama-item').data('id'),
    //                     video_id = $ele.data('video-id'),
    //                     videoURL = Helper.getVideoUrl({
    //                         videoId: video_id,
    //                         autoplay: true,
    //                         controls: true
    //                     }),
    //                     iframe = "<iframe src='"+videoURL+"' frameborder='0' class='videoplayer' allowfullscreen></iframe>";
                    
    //                 $ele.append(iframe).addClass('playing');
    //                 // Track TV Play event
    //                 setTimeout(function () {
    //                     // If player still exists
    //                     if($ele.children('iframe').length) {
    //                         require(['Mixpanel'], function (MixPanel) {
    //                             MixPanel.hit('user_event', {
    //                                 event: 'PT TV Play',
    //                                 page: 'tv',
    //                                 content_id: ama_id
    //                             });
    //                         });
    //                     }
    //                 }, 5000);

    //                 require(['Mixpanel'], function(MixPanel) {
    //                     MixPanel.hit('click', {target: 'tv video item',target_id: video_id});
    //                 });
    //                 return false;
    //             });

    //             UI.$b.on('click', '#btnSendFeedback', function (e) {
    //                 Helper.showFeedbackPage(e);
    //                 return false;
    //             });
    //         }*/
    //     },
    //     stuff: function () {
    //         // Call specific State
    //         // Feed update bubble
    //         var currentState = this.$elTopicHeader.data('state');

    //         if(this[currentState+'State'] && /before|live/.test(currentState)) {
    //             this.Topic.ama_info.state = currentState;
    //             this[currentState+'State']();
    //         } else if(Auth.check()) { // after
    //             this.showAMAVideo(true, {
    //                 autoplay: false
    //             });
    //         }
    //     },
    //     bindEvents: function () {
    //         var base = this;
    //         if(!base.Topic.ama_info.is_closed && Auth.check()) {
    //             // Also once AMA is closed
    //             // Show New Update
    //             var tmt = setTimeout(function () {
    //                 clearTimeout(tmt);
    //                 base.checkFeedUpdates();
    //             }, 30000);

    //             UI.$b.on('click', '#btnFeedUpdate', function () {
    //                 var $btn = $(this);
    //                 base.showFeedUpdateButton(false);
    //                 require(['Feed'], function (Feed) {
    //                     Feed.resetFeed(true, function () {
    //                         var tmt = setTimeout(function () {
    //                             clearTimeout(tmt);
    //                             base.checkFeedUpdates();
    //                         }, 20000);
    //                     });
    //                 });
    //                 UI.$hb.animate({ scrollTop: 0 }, 'fast');

    //                 return false;
    //             });
    //         }

    //         // LIVE VIDEO STREAMING
    //         UI.$b.on('click', '#btnStopAMAVideo', function () {
    //             base.showAMAVideo(false);
    //             return false;
    //         });
    //         UI.$b.on('click', '#btnWatchAMAVideo', function () {
    //             base.showAMAVideo();
    //             return false;
    //         });
    //         UI.$b.on('click', '#amaSeeDescription', function () {
    //             Helper.showDialog({
    //                 image: base.Topic.image,
    //                 heading: base.Topic.ama_info.short_desc,
    //                 description: "<strong>" + base.Topic.ama_info.expert_info.fullname + "</strong><br/><br/>" +
    //                             base.Topic.description,
    //             });
    //             return false;
    //         });
    //     },
    //     beforeState: function () {
    //         var base = this;
    //         // Run countdown
    //         // Change Status to LIVE and update Header
            
    //         // Load counter only if less then one day
    //         var msLeft = (new Date(base.Topic.ama_info.start_date)).getTime() - (new Date).getTime(),
    //             hoursLeft = msLeft/1000/60/60;
    //         if(hoursLeft <= 24.01) {
    //             startCountdown();
    //         } else if(hoursLeft <= 25) {
    //             var t = setTimeout(function () {
    //                 startCountdown();
    //                 clearTimeout(t);
    //             }, hoursLeft*60*60*1000);
    //         } else {
    //             return false;
    //         }

    //         function startCountdown() {
    //             require(['countdown'], function (Countdown) {
    //                 var $elTimer = base.$elTopicHeader.find('#amaTimer');
    //                 base.TIMER = new Countdown($elTimer[0], {
    //                     date: (new Date()).getTime() + (base.Topic.ama_info.seconds_to_start*1000),
    //                     onEnd: function () {
    //                         // Show popup that AMA started
    //                         base.liveState(base.TIMER);
    //                         Helper.showDialog({
    //                             image: base.Topic.ama_info.expert_info.image,
    //                             heading: 'Session has begun!',
    //                             description: base.Topic.ama_info.expert_info.fullname +' will help you to answer anything under the topic of <strong>'+base.Topic.name+'</strong>',
    //                             buttonText: 'Got it'
    //                         });
    //                     },
    //                     render: function(data) {
    //                         if(data.hours >= 1) { // If more than an hour
    //                             var h = ''+data.hours+'h '+data.min+'m';
    //                         }
    //                         else { // If less than an hour
    //                              var h = ''+data.min+'m '+data.sec+'s';
    //                         }
    //                         $elTimer.html(h);
    //                     }
    //                 });
    //             });
    //         }
    //     },
    //     liveState: function (TIMER) {
    //         var base = this;
    //         // Timer until END
    //         // Change Status to Live if not yet
    //         // Change Status to After and update Header
    //         // Disable Posting questions
    //         base.TIMER = TIMER || null;

    //         this.Topic.ama_info.state = 'live';

    //         if(base.$elTopicHeader.not('.state-live')) {
    //             base.$elTopicHeader.removeClass('state-before').addClass('state-live');
    //         }
    //         // Check if Video
    //         require(['countdown'], function (Countdown) {
    //             var $elTimer = base.$elTopicHeader.find('#amaTimer');
    //             var options = {
    //                 date: (new Date()).getTime() + (base.Topic.ama_info.seconds_to_end*1000),
    //                 onEnd: function () {
    //                     base.checkStatus(function (response) {
    //                         if(response && response.status === true) {
    //                             var t = response.response;
    //                             // Check if AMA extended
    //                             if(t.ama_info.is_live === 1) {
    //                                 base.Topic = t;
    //                                 base.TIMER.update((new Date).getTime()+base.Topic.ama_info.seconds_to_end*1000).start();
    //                             } else {
    //                                 base.afterState();
    //                             }
    //                         } else {
    //                             base.afterState();
    //                         }
    //                     });
    //                 },
    //                 render: function(data) {
    //                     if(data.hours >= 1) { // If more than an hour
    //                         var h = ''+data.hours+'h '+data.min+'m';
    //                     }
    //                     else if(data.hours <1 && data.min >= 1) { // If less than an hour and more than a minute
    //                          var h = ''+data.min+'m '+data.sec+'s';
    //                     }
    //                     else if(data.hours <1 && data.min < 1) { // If less than a minute
    //                          var h = ''+data.sec+'s';
    //                     }
    //                     h += "<small>to end</small>"
    //                     $elTimer.html(h);
    //                 }
    //             };

    //             // If reusing TIMER from before state
    //             if(base.TIMER) {
    //                 base.TIMER.restart(options);
    //             } else {
    //                 base.TIMER = new Countdown($elTimer[0], options);
    //             }

    //             if(base.Topic.ama_info.yt_video_id && Auth.check()) {
    //                 base.showAMAVideo();
    //             }
    //             base.checkFeedUpdates();
    //         });

    //         return false;
    //     },
    //     afterState: function () {
    //         var base = this;
    //         // Change Header if not yet
    //         // Disable Posting questions - ONLY IF IS_CLOSED = 1
            
    //         this.Topic.ama_info.state = 'after';
    //         if(base.$elTopicHeader.not('.state-after')) {
    //             base.$elTopicHeader.removeClass('state-before state-live').addClass('state-after');
    //         }
    //         base.showFeedUpdateButton(false);

    //         if(this.Topic.ama_info.is_closed === 1) {
    //             if($('#formAskWrap').length) {
    //                 $('#formAskWrap').remove();
    //             }
    //         }
    //         if(this.Topic.ama_info.yt_video_id) {
    //             base.showAMAVideo(false);
    //         }
    //     },
    //     checkStatus: function (callback) {
    //         var base = this;
    //         $.ajax({
    //             url: '/ajax/group/detail',
    //             data: {groupId: base.Topic.id},
    //             type: 'POST',
    //             success: function(response) {
    //                 if(callback) {
    //                     callback(response);
    //                 }
    //             },
    //             error: function () {
    //                 base.afterState();
    //             }
    //         });
    //     },
    //     checkFeedUpdates: function () {
    //         if(this.Topic.ama_info.state !== 'live') {
    //             return false;
    //         }
    //         var base = this,
    //             questionId = $('#feed').children('.feed-post').first().data('id');
    //         $.ajax({
    //             url: '/ajax/feed/check',
    //             data: {groupId: base.Topic.id, questionId: questionId},
    //             type: 'POST',
    //             success: function(response) {
    //                 if(response.status === true) {
    //                     if(response.response.new_feed >= 1) {
    //                         base.showFeedUpdateButton();
    //                     } else {
    //                         setTimeout(function () {
    //                             base.checkFeedUpdates();
    //                         }, 30000);
    //                     }
    //                 }
    //             }
    //         });
    //     },
    //     showFeedUpdateButton: function (show) {
    //         var $btn = $('#btnFeedUpdate');
    //         if(show === false) {
    //             $btn.addClass('hidden');
    //         } else {
    //             $btn.removeClass('hidden');
    //         }
    //     },
        
    //     showAMAVideo: function (show, options) {
    //         options = options || {};
    //         options.autoplay = options.autoplay === false ? false : true;
    //         if (!Auth.checkLoginRequired({source: 'ama watch video'})) {
    //             return false;
    //         }
    //         var base = this,
    //             $elAmaVideoWrapper = $('#amaHeaderVideoPane'),
    //             $elVideoPlayerFrame = $('#amaVideoFrame');
    //         if(show === false) {
    //             UI.$b.removeClass('amavideomode');
    //             base.$elTopicHeader.removeClass('hidden');
    //             $elAmaVideoWrapper.addClass('hidden');
    //             $elVideoPlayerFrame.attr('src', '');
    //             // Stop video as well
    //         } else {
    //             UI.$b.addClass('amavideomode');
    //             base.$elTopicHeader.addClass('hidden');
    //             $elAmaVideoWrapper.removeClass('hidden');
    //             // Stop video as well
    //             $elVideoPlayerFrame.attr('src', Helper.getVideoUrl({videoId: base.Topic.ama_info.yt_video_id, autoplay: options.autoplay}));

    //             // Hit TV Play event
    //             setTimeout(function () {
    //                 // If player still exists
    //                 if($elVideoPlayerFrame.attr('src')) {
    //                     require(['Mixpanel'], function (MixPanel) {
    //                         MixPanel.hit('user_event', {
    //                             event: 'PT TV Play',
    //                             page: 'Topic Page',
    //                             content_id: $elAmaVideoWrapper.data('id')
    //                         });
    //                     });
    //                 }
    //             }, 3000);
    //         }
    //     }
    // };

    // 
    // ONLY IF PLAYER EXISTS AND IS PLAYING
    // ON AUTOPLAY AND MANUAL PLAY
    // options = topicId, videoId, sourcePage, autoplay, videoiFrame, playfullscreen
    Groups.TVTrackAndPlay = function (options) {
        var defaults = {
            sourcePage :'Topic Page',
            autoplay: false,
            playfullscreen: false
        };
        var o = $.extend(defaults, options);
        if(!o.topicId || !o.videoId) {
            alert('Video/Topic not specified');
        }

        if(typeof window._gtap.settings.device !== 'undefined' && window._gtap.settings.device === 'mobile') {
            o.autoplay = false;
        }

        // Requires youtube iframe api
        if(!window.YT) {
            // retry in 500ms
            setTimeout(function () {
                Groups.TVTrackAndPlay(options);
            }, 500);
        } else {
            var player = new YT.Player('ytplayer_'+o.videoId, {
                height: '150',
                width: '300',
                videoId: o.videoId,
                playerVars: { 
                    showinfo: 0,
                    controls: 2
                },
                events: {
                  'onReady': onPlayerReady,
                  'onStateChange': onPlayerStateChange
                }
            });
            function onPlayerReady (e) {
                if(o.autoplay === true) {
                    e.target.playVideo();
                }
            }
            var ytstillplaying = false,
                yttimer;
            function onPlayerStateChange (e) {
                if(e.data == window.YT.PlayerState.PLAYING) {

                    if(ytstillplaying === true) {
                        return true;
                    } else {
                        ytstillplaying === true;
                        yttimer = setTimeout(function () {
                            require(['Mixpanel'], function (MixPanel) {
                                MixPanel.hit('user_event', {
                                    event: 'PT TV Play',
                                    page: o.sourcePage,
                                    content_id: o.topicId
                                });
                                // console.log('mixpanel hit');
                            });
                            
                        }, 3000);
                    }

                } else {
                    ytstillplaying = false;
                    clearTimeout(yttimer);
                }
            }
        }

        if(o.playfullscreen) {
            o.videoiFrame = document.getElementById('ytplayer_'+o.videoId);
            // play full screen
            var requestFullScreen = o.videoiFrame.requestFullScreen || o.videoiFrame.mozRequestFullScreen || o.videoiFrame.webkitRequestFullScreen;
            if (requestFullScreen && o.videoiFrame) {
                requestFullScreen.bind(o.videoiFrame)();
            }
        }
    };

    Groups.AMA = function () {
        // Group Video Page
        UI.$b.on('click', '.btn-see-video-summary', function () {
            var $btn = $(this);
            $btn.toggleClass('active').siblings('.vid-description').toggleClass('hidden');

            UI.$w.scroll();
            return false;
        });

        /**
         * Generate and play video
         */
        if(/^(group|group.tv_episode)$/.test(Config.get('page.route'))) {
            // If AMA page
            var TopicData = window._gtap.data.pageGroupData;
            if(parseInt(TopicData.type) === 1) {
                if(TopicData.ama_info.seconds_to_start > 2) {
                    return false;
                }
                Groups.TVTrackAndPlay({
                    topicId: TopicData.id,
                    videoId: TopicData.ama_info.yt_video_id,
                    autoplay: true,
                    sourcePage: 'Topic Page'
                });
            }
        }
    };
    
    Groups.init();

    return Groups;
});
